export default {
  nextValidDay() {
    const today = new Date();
    const nextDay = new Date(today);

    nextDay.setDate(today.getDate() + 1);

    return `${
      String(nextDay.getDate()).padStart(2, '0')
    }/${
      String(nextDay.getMonth() + 1).padStart(2, '0')
    }/${
      nextDay.getFullYear()
    }`;
  },
};
